import { transparentColors } from '@assets/styles/helpers/colors.styles'
import { floatingSurface } from '@/shared/styles/floatingSurface.styles'

export const colorPickerButtonStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.5rem',
  backgroundColor: transparentColors.whiteShade2,
  outline: 'none',
  '&:hover': {
    backgroundColor: transparentColors.whiteShade3
  },
  '&:active': {
    outline: 'none'
  },
  '&:focus': {
    outline: 'none'
  },
  '&:focus-within': {
    outline: 'none'
  }
}

export const tooltipStyles = {
  '&.MuiTooltip-tooltip': {
    ...floatingSurface,
    margin: '0.25rem 0 0 0 !important',
    padding: '0.75rem 0.75rem 1rem 0.75rem !important'
  }
}

export const popperStyles = {
  marginTop: '0.5rem !important',
  padding: '0.5rem'
}
